import React, { useContext, useEffect, useState, useRef } from 'react';
import { MapContainer, TileLayer, SVGOverlay } from 'react-leaflet';
import { Context } from '../Context';
import 'leaflet/dist/leaflet.css';
// import 'leaflet-sleep'; 
import styles from '../styles/bim.module.scss';
import Loading from './Loading';

function LocalizationView() {
    const { dataUrl, projectData, isMobile, loading, edificesData, tiersData} = useContext(Context);

    const [geo_cenlat, setgeo_cenlat] = useState(0);
    const [geo_cenlon, setgeo_cenlon] = useState(0);

    const [geo_r1lat, setgeo_r1lat] = useState(0);
    const [geo_r1lon, setgeo_r1lon] = useState(0);

    const [geo_r2lat, setgeo_r2lat] = useState(0);
    const [geo_r2lon, setgeo_r2lon] = useState(0);

    const [roatateAngle, setRotateAngle] = useState(0);

    const [tiersLayers, setTiersLayers] = useState([]);
    const mapRef = useRef(null);

    const imageBounds = [
        [geo_r1lat, geo_r1lon],
        [geo_r2lat, geo_r2lon]
    ];
    const center = [geo_cenlat, geo_cenlon];

    const groupStyle = {
        transformOrigin: 'center center',
        transform: `rotate(${roatateAngle}deg) scale(1.4)`,
        width: '100%',
        height: '100%',
        overflow: 'visible'
    };

    async function fetchTierLayers(edifice, tiers) {
        const newTierLayer = [];
        const pztPath = `${dataUrl}pzt.svg`;

        if (pztPath) {
            try {
                const tierSvg = await fetch(pztPath)
                    .then(res => res.text())
                    .then((text) => {
                        const modifiedText = text.replace(
                            /<image href="([^"]*)"/,
                            `<image href="${dataUrl}pzt.jpg"`
                        );
                        const modifiedTextPzt = modifiedText.replace(
                            /<svg([\s\S]*?)>/,
                            `<svg$1 class="pzt">`
                        );
                        newTierLayer.push(modifiedTextPzt);
                    });
            } catch (error) {
                console.error(`Błąd podczas pobierania ${pztPath}:`, error);
            }
        } else {
            for (const [index, tier] of tiers.entries()) {
                const svgName = `${index}.svg`;
                try {
                    const tierSvg = await fetch(`${dataUrl}edifices/${edifice}/tiers/${svgName}`)
                        .then(res => res.text())
                        .then((text) => {
                            const modifiedText = text.replace(
                                /<image href="([^"]*)"/,
                                `<image href="${dataUrl}pzt.jpg"`
                            );
                            newTierLayer.push(modifiedText);
                        });
                } catch (error) {
                    console.error(`Błąd podczas pobierania ${svgName}:`, error);
                }
            }
        }
        setTiersLayers(newTierLayer);
    }



    useEffect(() => {
        setgeo_cenlat(projectData.address.geo_cenlat ?? 0);
        setgeo_cenlon(projectData.address.geo_cenlon ?? 0);
        setgeo_r1lat(projectData.address.geo_r1lat ?? 0);
        setgeo_r1lon(projectData.address.geo_r1lon ?? 0);
        setgeo_r2lat(projectData.address.geo_r2lat ?? 0);
        setgeo_r2lon(projectData.address.geo_r2lon ?? 0);
        setRotateAngle(projectData.address.north_ang);
        fetchTierLayers(edificesData[0].name, tiersData);
    }, [loading, projectData]);

    useEffect(() => {
        if (geo_cenlat && geo_cenlon && geo_r1lon && geo_r1lat && geo_r2lon && geo_r2lat) {
            mapRef.current.setView([geo_cenlat, geo_cenlon], mapRef.current.getZoom());
        }
    }, [geo_cenlat, geo_cenlon, tiersLayers]);

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <MapContainer
                center={center}
                zoom={17}
                ref={mapRef}
                scrollWheelZoom={false}
                style={{ height: `${isMobile ? '100vh' : styles.visualization_height}` }}
            >
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
                />
                {geo_r1lon && roatateAngle && <>
                    {tiersLayers.map((tier, index) => (
                        <SVGOverlay
                            className={`${styles.tier_svg_layer} ${styles.localization_tier}`}
                            key={`tier_layer_${index}`}
                            bounds={imageBounds}
                        >
                            <g style={groupStyle} dangerouslySetInnerHTML={{ __html: tier }} />
                        </SVGOverlay>
                    ))}
                </>}
            </MapContainer>
        </>
    );
}

export default LocalizationView;
